export default __webpack_public_path__ + "static/Future_Driven_2020_KO_Lockup-f9eea151456ca4d5d890d735db005714.png";